module.exports = __webpack_public_path__ + "img/lumper-service.fd95c6af.svg";